import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import * as moment from "moment";
import { wsDisciplineDataParm, wsDisciplineIncidentDeleteParm } from "./ws-discipline-info";
import {
	wsDisciplineBasicIncidentStudentDataParm,
	wsDisciplineBasicIncidentCalendarDataParm,
	wsDisciplineBasicIncidentAddUpdateParm,
	wsDisciplineAdvancedIncidentStudentDataParm,
	wsDisciplineAdvancedIncidentCalendarDataParm,
	wsDisciplineAdvancedIncidentPenaltyRefreshParm,
	wsDisciplineAdvancedIncidentAddUpdateParm,
} from "./ws-discipline-modify-info";

@Injectable()
export class DataService_discipline {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	CreateGUID
	//
	//-----------------------------------------------------------------------------------------------------
	CreateGUID() {
		var postResult$ = new Subject();
		var url = "Discipline/CreateGUID";

		var promise$ = this.httpclientService.post(url, "");
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineIncidentGetData
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineIncidentGetData(parms: wsDisciplineDataParm) {
		var postResult$ = new Subject();
		var url = "Discipline/DisciplineIncidentGetData";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineIncidentDelete
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineIncidentDelete(parms: wsDisciplineIncidentDeleteParm) {
		var postResult$ = new Subject();
		var url = "Discipline/DisciplineIncidentDelete";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Print_IncidentReport
	//
	//-----------------------------------------------------------------------------------------------------
	Print_IncidentReport(ReportID: number, IncidentID: number, PersonID: number, isAlertsOnly: boolean, StartDate: Date, EndDate: Date) {
		var reportFileName: string = "";
		var strParam: string = "";
		var strStartDate: string = "";
		var strEndDate: string = "";

		//
		//	REPORT 1
		//
		if (ReportID == 1) {
			reportFileName = "RPTStudentDiscipline.rpx";

			//
			//	Build strParam
			//
			strStartDate = moment(StartDate).format("MM/DD/YYYY");
			strEndDate = moment(EndDate).format("MM/DD/YYYY");

			var strisAlertsOnly = "";

			if (isAlertsOnly == true) {
				strisAlertsOnly = "1";
			} else {
				strisAlertsOnly = "0";
			}

			strParam =
				PersonID.toString() +
				"|" +
				"PersonID," +
				strStartDate +
				"|" +
				"StartDate," +
				strEndDate +
				"|" +
				"EndDate," +
				strisAlertsOnly +
				"|" +
				"AlertsOnly," +
				"1" +
				"|" +
				"DateSort";
		}

		//
		//	REPORT 2
		//
		if (ReportID == 2) {
			reportFileName = "RPTSingleIncidentHistory.rpx";

			//
			//	Build strParam
			//
			strParam = IncidentID.toString() + "|" + "IncidentID";
		}

		//
		//	Generate PDF
		//
		var postResult$ = new Subject();
		var url = "Report/PrintByReportFileName?ReportFileName=" + reportFileName + "&strParam=" + strParam;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.next(error);
			}
		);

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//-----------------------------------------------------------------------------------------------------
	//	BASIC MODE SECTION
	//-----------------------------------------------------------------------------------------------------
	//-----------------------------------------------------------------------------------------------------

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineBasicIncidentGetStudentData
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineBasicIncidentGetStudentData(parms: wsDisciplineBasicIncidentStudentDataParm) {
		var postResult$ = new Subject();
		var url = "Discipline/DisciplineBasicIncidentGetStudentData";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineBasicIncidentGetCalendarData
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineBasicIncidentGetCalendarData(parms: wsDisciplineBasicIncidentCalendarDataParm) {
		var postResult$ = new Subject();
		var url = "Discipline/DisciplineBasicIncidentGetCalendarData";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineBasicIncidentAdd
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineBasicIncidentAdd(parms: wsDisciplineBasicIncidentAddUpdateParm) {
		var postResult$ = new Subject();
		var url = "Discipline/DisciplineBasicIncidentAdd";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineBasicIncidentUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineBasicIncidentUpdate(parms: wsDisciplineBasicIncidentAddUpdateParm) {
		var postResult$ = new Subject();
		var url = "Discipline/DisciplineBasicIncidentUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//-----------------------------------------------------------------------------------------------------
	//	ADVANCED MODE SECTION
	//-----------------------------------------------------------------------------------------------------
	//-----------------------------------------------------------------------------------------------------

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineAdvancedIncidentGetStudentData
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineAdvancedIncidentGetStudentData(parms: wsDisciplineAdvancedIncidentStudentDataParm) {
		var postResult$ = new Subject();
		var url = "Discipline/DisciplineAdvancedIncidentGetStudentData";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineAdvancedIncidentGetCalendarData
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineAdvancedIncidentGetCalendarData(parms: wsDisciplineAdvancedIncidentCalendarDataParm) {
		var postResult$ = new Subject();
		var url = "Discipline/DisciplineAdvancedIncidentGetCalendarData";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineAdvancedIncidentRefreshPenalty
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineAdvancedIncidentRefreshPenalty(parms: wsDisciplineAdvancedIncidentPenaltyRefreshParm) {
		var postResult$ = new Subject();
		var url = "Discipline/DisciplineAdvancedIncidentRefreshPenalty";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineAdvancedIncidentAdd
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineAdvancedIncidentAdd(parms: wsDisciplineAdvancedIncidentAddUpdateParm) {
		var postResult$ = new Subject();
		var url = "Discipline/DisciplineAdvancedIncidentAdd";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineAdvancedIncidentUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineAdvancedIncidentUpdate(parms: wsDisciplineAdvancedIncidentAddUpdateParm) {
		var postResult$ = new Subject();
		var url = "Discipline/DisciplineAdvancedIncidentUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
